import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { filter, switchMap, take, takeWhile } from 'rxjs';

import { AsyncJobSelectors, AsyncJobStatus } from '@core/async-job-data';
import { filterBoolean } from '@core/common-legacy';

import { OfferBulkSelectors } from '../store/bulk-actions/bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class OfferBulkActionsService {
  private readonly store = inject(Store);

  public trackByCorrelationId(correlationId: string) {
    return this.store.select(OfferBulkSelectors.byId(correlationId)).pipe(
      filterBoolean,
      filter(entity => !!entity.uuid),
      take(1),
      switchMap(({ uuid }) => this.store.select(AsyncJobSelectors.byId(uuid))),
      filterBoolean,
      takeWhile(job => job.status !== AsyncJobStatus.FINISHED, true),
    );
  }
}
